<template>
  <main class="page user-detail-page">
    <div class="page__back" @click="$router.push({name: 'UserList'})">
      <div class="page__back-icon">
        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 5.5H2M2 5.5L6.14815 1M2 5.5L6.14815 10" stroke="#95A4C0" stroke-width="1.5"/>
        </svg>
      </div>
      Назад
    </div>
    <section class="section page__header" v-if="user.id !== undefined">
      <div class="page__row">
        <div class="page__item mr-20">
          <AppAvatarPreview :avatar="user.avatar"/>
        </div>
        <div class="page__column">
          <h1 class="title">
            {{ user.profile.surname }} {{ user.profile.name }}<br>
            {{ user.profile.patronymic }}
          </h1>
          <div class="page__item">
            <h2 class="user-status"><b>Статус:&nbsp;</b>{{ status }}</h2>
          </div>
          <!-- статус в сети -->
          <!-- <div class="line-status online" v-if="user.isOnline">online</div>
          <div class="line-status offline" v-else>offline</div> -->
        </div>

        <div class="page__item self-start">
          <div class="page__row">
            <div class="page__item mr-40">
              <AppButtonSmEdit title="Редактировать" @click.native="updateUser"/>
            </div>
            <div class="page__item" v-if="roleAccessRemove">
              <AppButtonSmRemove title="Удалить" @click.native="showRemoveConfirmation"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section page__content" v-if="user.id !== undefined">
      <div class="user-detail-page__tabs">
        <AppTabsSlider :space-between="20" :tabs="tabs"/>
      </div>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </section>

    <section class="section page__footer">
    </section>

    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active"
                       text="Вы действительно хотите удалить этого сотрудника?"
                       @confirm="removeUser"
                       @reject="closeRemoveConfirmation"
      />
    </transition>
  </main>
</template>

<script>
import AppButtonSmEdit from '../../components/page/button/AppButtonSmEdit'
import AppButtonSmRemove from '../../components/page/button/AppButtonSmRemove'
import AppAvatarPreview from '../../components/page/files/AppAvatarPreview'
import AppConfirmation from '../../components/page/modal/AppConfirmation'
import AppTabsSlider from '@/components/page/tabs/AppTabsSlider'

export default {
  components: {
    AppTabsSlider,
    AppConfirmation,
    AppAvatarPreview,
    AppButtonSmRemove,
    AppButtonSmEdit
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        userId: null
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.userForDetail
    },
    status () {
      return this.user.status ? this.user.status.name : 'Не определен'
    },
    tabs () {
      return [{ name: 'Личная информация', routeName: 'UserDetail_personalTab' }]
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightsUsers.actions.remove
    },
    roleAccessUpdate () {
      return this.$store.getters.getRoleRightsUsers.actions.update
    },
    roleAccessCalendar () {
      return this.$store.getters.getRoleRightsUserActivityCalendar.access || this.user.id === this.currentUser.id
    }
  },
  methods: {
    updateUser () {
      const userId = this.$route.params.id
      this.$router.push({ path: `/user/update/${userId}` })
    },
    showRemoveConfirmation () {
      this.removeConfirmation.active = true
      this.removeConfirmation.userId = this.$route.params.id
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
    },
    removeUser () {
      this.$store.dispatch('deleteUserFromUserDetail', this.removeConfirmation.userId)
      this.$router.push({ path: '/user/list' })
    }
  },
  mounted () {
    const userId = this.$route.params.id
    this.$store.dispatch('getUserById', userId)
  },
  // обновляем данные в компоненте, после смены маршрута (для случаев когда находясь в этом же компоненте меняем
  // маршрут на редактирование другого пользователя)
  beforeRouteUpdate (to, from, next) {
    const userId = to.params.id
    this.$store.dispatch('getUserById', userId)
    next()
  }
}
</script>

<style lang="scss">
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.user-detail-page {
  padding-right: 75px;

  .page__header {
    padding-right: 20px;
  }

  &__tabs {
    margin-right: 20px;
    margin-bottom: 40px;
  }

  @media screen and (min-width: 1440px) {
    padding-right: 155px;
  }
}

.title {
  font-size: 20px;
  line-height: 1.2;
  margin-bottom: 18px;
}

.user-status {
  font-size: 16px;
  color: $font_color_second;
}

.line-status {
  font-size: 14px;
  font-weight: bold;

  &:before {
    content: '';
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin-right: 6px;
  }
}

.online {
  color: $color_fourth;

  &:before {
    background: $color_fourth;
    background: $color_fourth_gradient;
  }
}

.offline {
  color: $color_fifth;

  &:before {
    background: $color_fifth;
    background: $color_fifth_gradient;
  }
}

.subtitle {
  white-space: nowrap;
  margin-bottom: 34px;
}

.org-subtitle {
  font-size: 1.05em;
  color: $color__brown;
}

.department-title {
  font-weight: bold;
  color: $color__brown;
}

.cards-row {
  align-items: stretch;
  width: 100%;
  max-width: 1536px;
  flex-wrap: wrap;
}

.info-card {
  flex: 1;
  width: 100%;
  padding: 30px;
  margin-right: 20px;
  margin-bottom: 20px;
  background: $color__smoke;
  border-radius: 3px;

  &__item {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.data {
  display: flex;
  flex-flow: row nowrap;

  &__name {
    white-space: nowrap;
    color: $font_color_second;
    margin-right: 10px;
  }

  &__value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: $font_color_main;
  }
}

.user-card {
  display: flex;
  align-items: center;
  border: 1px solid $color__forest-wolf;
  border-radius: 3px;
  width: 294px;
  height: 90px;
  padding-right: 18px;
  padding-left: 22px;
  transition: .3s;

  &:hover {
    border-color: $color__copper-pink;
  }

  &:active {
    border-color: $color__orange;
  }
}

.user-list {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  max-width: 1536px;

  .user-card {
    margin-right: 16px;
    margin-bottom: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.large-info-card {
  flex-flow: column wrap;
  background: $color__smoke;
  border-radius: 3px;
  padding: 30px;
  max-width: 1536px;
  height: 220px;
  margin-right: 20px;

  &__item {
    width: auto;
    max-width: 50%;
    margin-right: 10px;
    margin-bottom: 12px;
  }
}

.docs-wrap {
  margin-bottom: 40px;

  &_no-items {
    color: $font_color_second;
  }
}

.family-wrap {
  &_no-items {
    color: $font_color_second;
  }
}

.doc-info-card {
  flex-flow: column nowrap;
  background: $color__smoke;
  border-radius: 3px;
  padding: 30px;
  max-width: 1536px;
  height: auto;
  margin-right: 20px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
